export function isCustomDomain(): boolean {
  const hostname = window.location.hostname;
  return (
    !hostname.includes("localhost") &&
    !hostname.includes("searchbubble")
  );}



  export function getPublicUrl(username: string, route: string): string {
    const hostname = window.location.hostname;
  
    const isCustomDomain = !hostname.includes("localhost") && !hostname.includes("searchbubble");
  
    if (isCustomDomain) {
      // For proxy domain like searchable.me → use domain + route only
      return `${window.location.origin}/${route}`;
    } else {
      // For localhost and production → include username in the path
      return `${window.location.origin}/${username}/${route}`;
    }
  }


  
  export function getPublicUrlWithUsername(username: string, route: string): string {
    const hostname = window.location.hostname;
  
    const isCustomDomain = !hostname.includes("localhost") && !hostname.includes("searchbubble");
  
    if (isCustomDomain) {
      // For proxy domain like searchable.me → use domain + route only
      return `/${route}`;
    } else {
      // For localhost and production → include username in the path
      return `/${username}/${route}`;
    }
  }


  export function getHomePath(username: string): string {
    const hostname = window.location.hostname;
  
    const isCustomDomain = !hostname.includes("localhost") && !hostname.includes("searchbubble");
  
    return isCustomDomain ? "/" : `/${username}`;
  }
  
  